// Module
var code = "<div class=\"oe-selector\" style=\"{{>visibility}}\">\r\n    <terceraLabel text=\"{{label}}\" />\r\n\r\n    <div class=\"oe-selector-right\">\r\n        <terceraComboBox showLastValue=\"true\"\r\n                         items=\"{{dp.objectVariants}}\"\r\n                         selectedItem=\"{{boundToItem}}\" />\r\n    </div>\r\n</div>";
// Exports
export default code;